class TimerServiceController {
	public getRemainTime(): Date {
		const UPDATE_EVERY = 3600000; // 60mins

		return new Date(UPDATE_EVERY - (new Date().getTime() % UPDATE_EVERY));
	}
}

export const TimerSevice = new TimerServiceController();
